/*
  TROVI Marketplace · barra inferior sticky de la ficha (<990px).
  No reimplementa el carrito: el botón de la barra es un submit del mismo
  <form> de Dawn (atributo form=), así que product-form.js hace todo el trabajo.
  La barra solo refleja precio, texto y estado deshabilitado del botón real.
*/
(function () {
  'use strict';

  function init(bar) {
    if (bar.dataset.tvInit === 'true') return;
    bar.dataset.tvInit = 'true';

    var sectionId = bar.dataset.sectionId;
    var priceTarget = bar.querySelector('[data-tv-sticky-price]');
    var barButton = bar.querySelector('[data-tv-sticky-button]');
    var anchor = document.getElementById('TvBuybox-' + sectionId);

    function syncPrice() {
      if (!priceTarget) return;
      var source = document.getElementById('price-' + sectionId);
      var price = source && source.querySelector('.price');
      var amount = price && price.querySelector(price.classList.contains('price--on-sale')
        ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
      var text = '';
      var visible = !!amount;
      for (var node = amount; node && node !== bar.parentElement; node = node.parentElement) {
        if (node.hidden || node.classList.contains('hidden') || node.classList.contains('tv-hidden') || window.getComputedStyle(node).display === 'none') visible = false;
      }
      if (visible) {
        // TROVI's accessible amount already includes decimal/currency formatting.
        // Do not concatenate its visual digits or the separate regular-price label.
        var formatted = amount.querySelector('.tv-visually-hidden');
        if (formatted) text = formatted.textContent;
        else {
          var copy = amount.cloneNode(true);
          copy.querySelectorAll('.visually-hidden,.tv-visually-hidden,[hidden],[aria-hidden="true"]').forEach(function (child) { child.remove(); });
          text = copy.textContent;
        }
      }
      priceTarget.textContent = (text || '').replace(/\s+/g, ' ').trim();
    }

    function syncButton() {
      if (!barButton) return;
      var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
      var disabled = !mainButton || mainButton.hasAttribute('disabled') || !priceTarget || !priceTarget.textContent;
      if (disabled) {
        barButton.setAttribute('disabled', 'disabled');
      } else {
        barButton.removeAttribute('disabled');
      }
      var label = mainButton && mainButton.querySelector('span');
      var barLabel = barButton.querySelector('span');
      if (label && barLabel) barLabel.textContent = label.textContent.trim();
    }

    syncPrice();
    syncButton();

    if (window.MutationObserver) {
      // Variant changes replace the buybox contents; observe their stable parent
      // and resolve price/button again, rather than retaining detached nodes.
      var scope = bar.closest('.shopify-section') || bar.parentElement;
      var observer = new MutationObserver(function (changes) {
        if (changes.some(function (change) { return !bar.contains(change.target); })) {
          syncPrice();
          syncButton();
        }
      });
      observer.observe(scope, {
        attributes: true, attributeFilter: ['disabled', 'class', 'hidden', 'style'],
        childList: true, subtree: true, characterData: true,
      });
    }

    // visible solo cuando el buy box real ya no está en pantalla
    if ('IntersectionObserver' in window && anchor) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -40px 0px' }
      ).observe(anchor);
    } else {
      bar.classList.add('is-visible');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-tv-sticky-atc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
